import { render, staticRenderFns } from "./FabuSuccess.vue?vue&type=template&id=ad540b44&scoped=true"
import script from "./FabuSuccess.vue?vue&type=script&lang=js"
export * from "./FabuSuccess.vue?vue&type=script&lang=js"
import style0 from "./FabuSuccess.vue?vue&type=style&index=0&id=ad540b44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad540b44",
  null
  
)

export default component.exports